import axios, { AxiosError } from "axios";
import { jwtDecode } from "jwt-decode";
import { axiosErrorMessages, Logout } from "./api";
import { enqueueSnackbar, VariantType } from "notistack";
import { useNavigate } from "react-router-dom";

export const getToken = () => {
  // Retrieve the token from local storage
  return localStorage.getItem("token");
};

export const isAuthenticated = () => {
  // Check if the user is authenticated
  const token = getToken();
  return token !== null;
};

export const onLogout = async () => {
  try {
    const response = await Logout();
    const type: VariantType = "success";
    enqueueSnackbar(response?.data?.message, {
      variant: "success",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
    if (
      response?.status === 200 ||
      response?.data === "Token Not Found" ||
      response?.data?.message === "No Active Session Found"
    ) {
      localStorage.clear();
      if (process.env.NODE_ENV === "development") {
        const expirationTime = new Date(new Date().getTime() - 1).toUTCString(); // 5 minutes from now
        document.cookie = `CASAuthCookie=; path=/; secure=true; samesite=None; expires=${expirationTime}`;
      }
    }
  } catch (error: any) {
    let errorMsg;
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      errorMsg = axiosErrorMessages(axiosError);

      const type: VariantType = "error";
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
  }
};

export const isTokenExpired = (token: string): boolean => {
  // Decode the token to get its expiration time
  const decodedToken: any = jwtDecode(token);
  if (!decodedToken) return true;
  const expirationTime: number = decodedToken.exp * 1000; // Convert to milliseconds
  return Date.now() >= expirationTime;
};
